import { TTLCache } from '@isaacs/ttlcache';
import type { ContentfulModel } from '@troon/contentful';

export const defaultTTL = 600_000;
export const ttlCache = new TTLCache({ ttl: defaultTTL, checkAgeOnGet: true, max: 500 });

export const modelTTLOverride: Partial<Record<ContentfulModel, number>> = {
	configs: 3_600_000, // one hour, since this is going to be requested on every single request
};
